import { useState } from "react";
import ReportSelector4 from "./ReportSelector4";
import axios from "axios";
import Loader from "./Loader";
import ThreeDotLoader from "./ThreeDotLoader";
import OrderedMaterials from "./OrderedMaterials";
import ExportToExcelBTN2 from "./ExportToExcelBTN2";
import { useUser } from "../Contexts/UserContext";
import downloadExcel from "./DownloadExcel";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const processMaterials = (materials) => {
  const materialMap = new Map();

  materials.forEach((material) => {
    const quantity = parseInt(material.materialQuantity, 10);
    if (materialMap.has(material.materialName)) {
      const existingMaterial = materialMap.get(material.materialName);
      console.log(existingMaterial);
      existingMaterial.materialQuantity += quantity;
    } else {
      materialMap.set(material.materialName, {
        ...material,
        materialQuantity: quantity,
      });
    }
  });

  return Array.from(materialMap.values());
};
const MaterialsPage = () => {
  const { user } = useUser();
  const [materials, setMaterials] = useState([]);
  const [selectedData, setSelectedData] = useState({
    unitObj: null,
    branchObj: null,
    monthObj: null,
  });
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isReportFetched, setIsReportFetched] = useState(false);
  const { ClientId } = user;
  const fetchAllMaterials = async () => {
    const rawData = await fetch(
      `${API_URL}/facility/GetPivotReport/1/${ClientId}/${fromDate}/${toDate}`
    ).then((res) => res.json());
    setMaterials(rawData.data);
  };
  const handleFetchReports = async () => {
    try {
      setIsLoading(true);
      if (selectedData.unitObj.UnitCode == "ALL") {
        await fetchAllMaterials();
        setIsLoading(false);
        setIsReportFetched(true);
        return;
      }
      const response = await fetch(
        `${API_URL}/facility/GetOrderedMaterialsListByUnitCode2/${selectedData.unitObj.UnitCode}/${fromDate}/${toDate}`
      ).then((res) => res.json());
      if (response.success) {
        setIsLoading(false);
        const processedMaterials = processMaterials(response.data);
        setMaterials(processedMaterials);
      }
      setIsReportFetched(true);
    } catch (error) {
      console.error("Error fetching materials:", error);
    }
  };
  return (
    <>
      <div style={{ padding: "2rem 4rem" }}>
        <ReportSelector4
          title={"Materials"}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          fromDate={fromDate}
          setFromDate={setFromDate}
          toDate={toDate}
          setToDate={setToDate}
          handleFetchReports={handleFetchReports}
          setIsReportFetched={setIsReportFetched}
        />
        {/* <Loader /> */}
        {isLoading ? (
          <ThreeDotLoader />
        ) : selectedData.unitObj?.UnitCode !== "ALL" ? (
          materials.length ? (
            isReportFetched ? (
              <OrderedMaterials
                materials={materials}
                selectedData={selectedData}
              />
            ) : (
              <span>No Data To Show!</span>
            )
          ) : isReportFetched ? (
            <span>No Data Found!</span>
          ) : (
            <span>No Data To Show!</span>
          )
        ) : isReportFetched ? (
          <ExportToExcelBTN2 data={materials} />
        ) : (
          <span>No Data To Show!</span>
        )}
      </div>
    </>
  );
};
export default MaterialsPage;
